module.exports = __webpack_public_path__ + "static/media/icon-pwdchange.0985b4e7.svg";